{
  "file": {
    "filename": "fed.xlsx",
    "url": "https://www.fedsmallbusiness.org/-/media/project/clevelandfedtenant/fsbsite/reports/2026/sbcs-employer-firms-appendix-2025.xlsx",
    "sha256": "ce5b80dcbaad11ce294e7c2c60a29dd48eaac3f74904ed3554c190f7977a3958"
  },
  "publicationDate": "2026-03-03",
  "surveyYear": 2025,
  "groups": [
    {
      "id": "challenges",
      "question": "Financial challenges, prior 12 months",
      "rows": [
        {
          "label": "Increased costs of goods, services, and/or wages",
          "value": 73.0,
          "sampleSize": 6500,
          "confidenceInterval": "(70.9%, 74.8%)",
          "cell": "D355",
          "sampleCell": "E355",
          "intervalCell": "F355"
        },
        {
          "label": "Paying operating expenses",
          "value": 54.0,
          "sampleSize": 6500,
          "confidenceInterval": "(52.0%, 55.4%)",
          "cell": "D356",
          "sampleCell": "E356",
          "intervalCell": "F356"
        },
        {
          "label": "Uneven cash flow (including collecting on receivables)",
          "value": 50.0,
          "sampleSize": 6500,
          "confidenceInterval": "(47.6%, 51.6%)",
          "cell": "D357",
          "sampleCell": "E357",
          "intervalCell": "F357"
        },
        {
          "label": "Weak sales",
          "value": 48.0,
          "sampleSize": 6500,
          "confidenceInterval": "(46.0%, 49.8%)",
          "cell": "D358",
          "sampleCell": "E358",
          "intervalCell": "F358"
        },
        {
          "label": "Increased costs associated with tariffs",
          "value": 42.0,
          "sampleSize": 6500,
          "confidenceInterval": "(39.6%, 44.1%)",
          "cell": "D359",
          "sampleCell": "E359",
          "intervalCell": "F359"
        },
        {
          "label": "Making payments on debt / interest rates",
          "value": 33.0,
          "sampleSize": 6500,
          "confidenceInterval": "(30.8%, 35.4%)",
          "cell": "D360",
          "sampleCell": "E360",
          "intervalCell": "F360"
        },
        {
          "label": "Credit availability",
          "value": 29.0,
          "sampleSize": 6500,
          "confidenceInterval": "(27.4%, 30.5%)",
          "cell": "D361",
          "sampleCell": "E361",
          "intervalCell": "F361"
        },
        {
          "label": "Other",
          "value": 1.0,
          "sampleSize": 6500,
          "confidenceInterval": "(00.3%, 00.8%)",
          "cell": "D362",
          "sampleCell": "E362",
          "intervalCell": "F362"
        },
        {
          "label": "Did not experience any financial challenges",
          "value": 6.0,
          "sampleSize": 6500,
          "confidenceInterval": "(04.9%, 06.7%)",
          "cell": "D363",
          "sampleCell": "E363",
          "intervalCell": "F363"
        }
      ]
    },
    {
      "id": "actions",
      "question": "Actions taken in response to financial challenges, prior 12 months",
      "rows": [
        {
          "label": "Used personal funds",
          "value": 54.0,
          "sampleSize": 6183,
          "confidenceInterval": "(51.7%, 55.4%)",
          "cell": "D32",
          "sampleCell": "E32",
          "intervalCell": "F32"
        },
        {
          "label": "Raised prices the business charges",
          "value": 48.0,
          "sampleSize": 6183,
          "confidenceInterval": "(45.9%, 49.6%)",
          "cell": "D33",
          "sampleCell": "E33",
          "intervalCell": "F33"
        },
        {
          "label": "Used cash reserves",
          "value": 47.0,
          "sampleSize": 6183,
          "confidenceInterval": "(45.1%, 49.8%)",
          "cell": "D34",
          "sampleCell": "E34",
          "intervalCell": "F34"
        },
        {
          "label": "Reduced costs",
          "value": 47.0,
          "sampleSize": 6183,
          "confidenceInterval": "(45.4%, 49.6%)",
          "cell": "D35",
          "sampleCell": "E35",
          "intervalCell": "F35"
        },
        {
          "label": "Took out debt",
          "value": 36.0,
          "sampleSize": 6183,
          "confidenceInterval": "(33.8%, 37.6%)",
          "cell": "D36",
          "sampleCell": "E36",
          "intervalCell": "F36"
        },
        {
          "label": "Downsized operations",
          "value": 31.0,
          "sampleSize": 6183,
          "confidenceInterval": "(29.4%, 32.8%)",
          "cell": "D37",
          "sampleCell": "E37",
          "intervalCell": "F37"
        },
        {
          "label": "Made a late payment or did not pay",
          "value": 24.0,
          "sampleSize": 6183,
          "confidenceInterval": "(22.6%, 26.0%)",
          "cell": "D38",
          "sampleCell": "E38",
          "intervalCell": "F38"
        },
        {
          "label": "Other",
          "value": 3.0,
          "sampleSize": 6183,
          "confidenceInterval": "(02.0%, 03.3%)",
          "cell": "D39",
          "sampleCell": "E39",
          "intervalCell": "F39"
        },
        {
          "label": "No action",
          "value": 5.0,
          "sampleSize": 6183,
          "confidenceInterval": "(04.4%, 06.5%)",
          "cell": "D40",
          "sampleCell": "E40",
          "intervalCell": "F40"
        }
      ]
    },
    {
      "id": "condition",
      "question": "Financial condition, at time of survey",
      "rows": [
        {
          "label": "Poor",
          "value": 22.0,
          "sampleSize": 6523,
          "confidenceInterval": "(20.6%, 23.2%)",
          "cell": "D364",
          "sampleCell": "E364",
          "intervalCell": "F364"
        },
        {
          "label": "Fair",
          "value": 35.0,
          "sampleSize": 6523,
          "confidenceInterval": "(33.5%, 37.4%)",
          "cell": "D365",
          "sampleCell": "E365",
          "intervalCell": "F365"
        },
        {
          "label": "Good",
          "value": 26.0,
          "sampleSize": 6523,
          "confidenceInterval": "(24.8%, 27.6%)",
          "cell": "D366",
          "sampleCell": "E366",
          "intervalCell": "F366"
        },
        {
          "label": "Very good",
          "value": 12.0,
          "sampleSize": 6523,
          "confidenceInterval": "(10.6%, 12.8%)",
          "cell": "D367",
          "sampleCell": "E367",
          "intervalCell": "F367"
        },
        {
          "label": "Excellent",
          "value": 5.0,
          "sampleSize": 6523,
          "confidenceInterval": "(04.3%, 05.5%)",
          "cell": "D368",
          "sampleCell": "E368",
          "intervalCell": "F368"
        }
      ]
    },
    {
      "id": "products",
      "question": "Financing products regularly used",
      "rows": [
        {
          "label": "Credit card",
          "value": 62.0,
          "sampleSize": 6525,
          "confidenceInterval": "(59.7%, 63.8%)",
          "cell": "D382",
          "sampleCell": "E382",
          "intervalCell": "F382"
        },
        {
          "label": "Loan",
          "value": 44.0,
          "sampleSize": 6525,
          "confidenceInterval": "(42.1%, 45.6%)",
          "cell": "D383",
          "sampleCell": "E383",
          "intervalCell": "F383"
        },
        {
          "label": "Line of credit",
          "value": 36.0,
          "sampleSize": 6525,
          "confidenceInterval": "(34.3%, 37.5%)",
          "cell": "D384",
          "sampleCell": "E384",
          "intervalCell": "F384"
        },
        {
          "label": "Trade credit",
          "value": 19.0,
          "sampleSize": 6525,
          "confidenceInterval": "(17.4%, 20.5%)",
          "cell": "D385",
          "sampleCell": "E385",
          "intervalCell": "F385"
        },
        {
          "label": "Lease",
          "value": 14.0,
          "sampleSize": 6525,
          "confidenceInterval": "(13.3%, 15.3%)",
          "cell": "D386",
          "sampleCell": "E386",
          "intervalCell": "F386"
        },
        {
          "label": "Merchant cash advance",
          "value": 7.0,
          "sampleSize": 6525,
          "confidenceInterval": "(06.2%, 08.4%)",
          "cell": "D387",
          "sampleCell": "E387",
          "intervalCell": "F387"
        },
        {
          "label": "Factoring",
          "value": 3.0,
          "sampleSize": 6525,
          "confidenceInterval": "(02.2%, 03.3%)",
          "cell": "D388",
          "sampleCell": "E388",
          "intervalCell": "F388"
        },
        {
          "label": "Other",
          "value": 0.0,
          "sampleSize": 6525,
          "confidenceInterval": "(00.0%, 00.1%)",
          "cell": "D389",
          "sampleCell": "E389",
          "intervalCell": "F389"
        },
        {
          "label": "Business does not use external financing",
          "value": 14.0,
          "sampleSize": 6525,
          "confidenceInterval": "(12.5%, 15.5%)",
          "cell": "D390",
          "sampleCell": "E390",
          "intervalCell": "F390"
        }
      ]
    },
    {
      "id": "reasons",
      "question": "Reasons for applying for financing, prior 12 months",
      "rows": [
        {
          "label": "Meet operating expenses",
          "value": 56.0,
          "sampleSize": 3638,
          "confidenceInterval": "(54.0%, 59.0%)",
          "cell": "D520",
          "sampleCell": "E520",
          "intervalCell": "F520"
        },
        {
          "label": "Expand business, pursue new opportunity, or acquire business assets",
          "value": 46.0,
          "sampleSize": 3638,
          "confidenceInterval": "(43.3%, 49.3%)",
          "cell": "D521",
          "sampleCell": "E521",
          "intervalCell": "F521"
        },
        {
          "label": "Have available credit for future use as needed",
          "value": 42.0,
          "sampleSize": 3638,
          "confidenceInterval": "(39.1%, 45.2%)",
          "cell": "D522",
          "sampleCell": "E522",
          "intervalCell": "F522"
        },
        {
          "label": "Refinance or pay down debt",
          "value": 28.0,
          "sampleSize": 3638,
          "confidenceInterval": "(26.4%, 30.5%)",
          "cell": "D523",
          "sampleCell": "E523",
          "intervalCell": "F523"
        },
        {
          "label": "Make repairs or replace capital assets",
          "value": 26.0,
          "sampleSize": 3638,
          "confidenceInterval": "(23.9%, 29.2%)",
          "cell": "D524",
          "sampleCell": "E524",
          "intervalCell": "F524"
        },
        {
          "label": "Other",
          "value": 0.0,
          "sampleSize": 3638,
          "confidenceInterval": "(00.2%, 00.7%)",
          "cell": "D525",
          "sampleCell": "E525",
          "intervalCell": "F525"
        }
      ]
    },
    {
      "id": "received",
      "question": "Total financing received, prior 12 months",
      "rows": [
        {
          "label": "None",
          "value": 22.0,
          "sampleSize": 3654,
          "confidenceInterval": "(19.4%, 25.1%)",
          "cell": "D574",
          "sampleCell": "E574",
          "intervalCell": "F574"
        },
        {
          "label": "Some (1–50%)",
          "value": 21.0,
          "sampleSize": 3654,
          "confidenceInterval": "(19.1%, 23.3%)",
          "cell": "D575",
          "sampleCell": "E575",
          "intervalCell": "F575"
        },
        {
          "label": "Most (51–99%)",
          "value": 15.0,
          "sampleSize": 3654,
          "confidenceInterval": "(13.3%, 16.8%)",
          "cell": "D576",
          "sampleCell": "E576",
          "intervalCell": "F576"
        },
        {
          "label": "All",
          "value": 42.0,
          "sampleSize": 3654,
          "confidenceInterval": "(39.3%, 44.5%)",
          "cell": "D577",
          "sampleCell": "E577",
          "intervalCell": "F577"
        }
      ]
    },
    {
      "id": "debt",
      "question": "Amount of outstanding debt, at time of survey",
      "rows": [
        {
          "label": "No outstanding debt",
          "value": 31.0,
          "sampleSize": 6447,
          "confidenceInterval": "(28.8%, 32.3%)",
          "cell": "D60",
          "sampleCell": "E60",
          "intervalCell": "F60"
        },
        {
          "label": "≤$25K",
          "value": 10.0,
          "sampleSize": 6447,
          "confidenceInterval": "(09.0%, 11.3%)",
          "cell": "D61",
          "sampleCell": "E61",
          "intervalCell": "F61"
        },
        {
          "label": "$25K–$50K",
          "value": 10.0,
          "sampleSize": 6447,
          "confidenceInterval": "(08.7%, 11.5%)",
          "cell": "D62",
          "sampleCell": "E62",
          "intervalCell": "F62"
        },
        {
          "label": "$50K–$100K",
          "value": 12.0,
          "sampleSize": 6447,
          "confidenceInterval": "(10.6%, 12.6%)",
          "cell": "D63",
          "sampleCell": "E63",
          "intervalCell": "F63"
        },
        {
          "label": "$100K–$250K",
          "value": 15.0,
          "sampleSize": 6447,
          "confidenceInterval": "(13.7%, 16.3%)",
          "cell": "D64",
          "sampleCell": "E64",
          "intervalCell": "F64"
        },
        {
          "label": "$250K–$1M",
          "value": 15.0,
          "sampleSize": 6447,
          "confidenceInterval": "(13.5%, 16.4%)",
          "cell": "D65",
          "sampleCell": "E65",
          "intervalCell": "F65"
        },
        {
          "label": ">$1M",
          "value": 8.0,
          "sampleSize": 6447,
          "confidenceInterval": "(07.2%, 08.9%)",
          "cell": "D66",
          "sampleCell": "E66",
          "intervalCell": "F66"
        }
      ]
    },
    {
      "id": "collateral",
      "question": "Type of collateral used to secure debt",
      "rows": [
        {
          "label": "Personal guarantee",
          "value": 59.0,
          "sampleSize": 4651,
          "confidenceInterval": "(57.3%, 61.1%)",
          "cell": "D578",
          "sampleCell": "E578",
          "intervalCell": "F578"
        },
        {
          "label": "Business assets",
          "value": 51.0,
          "sampleSize": 4651,
          "confidenceInterval": "(48.8%, 53.7%)",
          "cell": "D579",
          "sampleCell": "E579",
          "intervalCell": "F579"
        },
        {
          "label": "Personal assets",
          "value": 38.0,
          "sampleSize": 4651,
          "confidenceInterval": "(35.1%, 40.0%)",
          "cell": "D580",
          "sampleCell": "E580",
          "intervalCell": "F580"
        },
        {
          "label": "Portions of future sales",
          "value": 10.0,
          "sampleSize": 4651,
          "confidenceInterval": "(08.6%, 11.1%)",
          "cell": "D581",
          "sampleCell": "E581",
          "intervalCell": "F581"
        },
        {
          "label": "Other collateral or guarantee",
          "value": 0.0,
          "sampleSize": 4651,
          "confidenceInterval": "--",
          "cell": "D582",
          "sampleCell": "E582",
          "intervalCell": "F582"
        },
        {
          "label": "No collateral or guarantee",
          "value": 10.0,
          "sampleSize": 4651,
          "confidenceInterval": "(08.4%, 11.4%)",
          "cell": "D583",
          "sampleCell": "E583",
          "intervalCell": "F583"
        }
      ]
    },
    {
      "id": "nonapplicants",
      "question": "Primary reason for not applying for financing",
      "rows": [
        {
          "label": "Not needed / had sufficient financing",
          "value": 63.0,
          "sampleSize": 2556,
          "confidenceInterval": "(60.6%, 66.0%)",
          "cell": "D461",
          "sampleCell": "E461",
          "intervalCell": "F461"
        },
        {
          "label": "Discouraged",
          "value": 10.0,
          "sampleSize": 2556,
          "confidenceInterval": "(08.6%, 11.9%)",
          "cell": "D462",
          "sampleCell": "E462",
          "intervalCell": "F462"
        },
        {
          "label": "Debt averse",
          "value": 17.0,
          "sampleSize": 2556,
          "confidenceInterval": "(14.5%, 19.0%)",
          "cell": "D463",
          "sampleCell": "E463",
          "intervalCell": "F463"
        },
        {
          "label": "Credit cost was too high",
          "value": 7.0,
          "sampleSize": 2556,
          "confidenceInterval": "(06.0%, 09.1%)",
          "cell": "D464",
          "sampleCell": "E464",
          "intervalCell": "F464"
        },
        {
          "label": "Application process was too difficult or confusing",
          "value": 2.0,
          "sampleSize": 2556,
          "confidenceInterval": "(01.2%, 02.7%)",
          "cell": "D465",
          "sampleCell": "E465",
          "intervalCell": "F465"
        },
        {
          "label": "Other",
          "value": 1.0,
          "sampleSize": 2556,
          "confidenceInterval": "(00.5%, 01.3%)",
          "cell": "D466",
          "sampleCell": "E466",
          "intervalCell": "F466"
        }
      ]
    }
  ]
}
